import { ADD_ADDRESS_REQUEST, ADD_ADDRESS_SUCCESS, ADD_ADDRESS_ERROR } from '../constants/ActionTypes'
import GenericAction from './types/genericAction.types'


export type AddAddressAction = GenericAction<typeof ADD_ADDRESS_REQUEST | typeof ADD_ADDRESS_SUCCESS | typeof ADD_ADDRESS_ERROR, { error?: any }>

export type AddAddress = (state: State, action: AddAddressAction) => State

type State = {
    loading: boolean
    error: any
}

const initialState: State = {
    loading: false,
    error: null,
}

const addAddress = (state = initialState, action: AddAddressAction) => {
    switch (action.type) {
        case ADD_ADDRESS_REQUEST:
            return { ...state, loading: true, error: null }
        case ADD_ADDRESS_SUCCESS:
            return { ...state, loading: false, error: null }
        case ADD_ADDRESS_ERROR:
            return { ...state, loading: false, error: action.error }
        default:
            return state
    }
}

export default addAddress
